import Mask from './Mask'
import { StylesObj } from './styles'
export default Mask
export { Mask }
export type { StylesObj as MaskStylesObj }
